import { useState } from "react";
import {
  JhDropdownMenu,
  JhDropdownMenuTrigger,
  JhDropdownMenuContent,
  JhDropdownMenuItem
} from "designPackages/dropDown";
import { JhText } from "designPackages/textPackage";
import { CheckIcon, ListFilter } from "lucide-react";
import { useIsMobile } from "hooks/useDeviceType";

interface FilterOption {
  value: string;
  label: string;
  count?: number;
}

interface TransactionHistoryV2TableHeaderProps {
  onFilterSelect?: (filter: string) => void;
  filterOptions?: FilterOption[];
  selectedTab?: string;
}


const TransactionHistoryV2TableHeader = ({
  onFilterSelect,
  filterOptions = [],
  selectedTab = "ALL"
}: TransactionHistoryV2TableHeaderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useIsMobile();

  const handleFilterSelect = (filterValue: string) => {
    setIsOpen(false);
    onFilterSelect?.(filterValue);
  };

  const selectedOption = filterOptions.find(
    opt => opt.value === selectedTab
  );
  const selectedLabel = selectedOption?.label || "All Transactions";

  // On mobile, show just the text without dropdown functionality
  if (isMobile) {
    return (
      <JhText variant="subtitle4" color="muted-foreground">
        {selectedLabel}
      </JhText>
    );
  }

  // On desktop, show the dropdown
  return (
    <JhDropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <JhDropdownMenuTrigger asChild>
        <button className="flex items-center gap-2 hover:text-foreground transition-colors cursor-pointer text-">
          <JhText variant="subtitle4" color="muted-foreground">
            {selectedLabel}
          </JhText>
          <ListFilter className="w-4 h-4" />
        </button>
      </JhDropdownMenuTrigger>
      <JhDropdownMenuContent align="start" className="w-56">
        {filterOptions.map(option => {
          const optionLabel =
            option.count !== undefined
              ? `${option.label} (${option.count})`
              : option.label;

          return (
            <JhDropdownMenuItem
              key={option.value}
              onClick={() => handleFilterSelect(option.value)}
              disabled={option.count === 0}
              className={option.value === selectedTab ? "bg-slate-100 flex items-center justify-between" : undefined}
            >
              <JhText
                variant="body2"
                color={
                  option.value === selectedTab ? "foreground" : undefined
                }
              >
                {optionLabel}
              </JhText>
              {option.value === selectedTab && <CheckIcon className="size-4 text-muted-foreground" />} {/* currently no check icon in design package */}
            </JhDropdownMenuItem>
          );
        })}
      </JhDropdownMenuContent>
    </JhDropdownMenu>
  );
};

export default TransactionHistoryV2TableHeader;
